<template>
  <div
    class="flex items-start text-xs font-medium rounded-sm px-2 py-1"
    :class="color"
  >
    <span
      class="material-symbols-outlined font-medium text-xl leading-4 mr-1 -ml-1"
      >{{ icon }}</span
    >
    <span>{{ name }}</span>
  </div>
</template>
<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  category: {
    required: true,
    type: Object,
  },
});

const name = computed(() => {
  return props.category.name;
});

const icon = computed(() => {
  return props.category.icon;
});

const color = computed(() => ({
  "text-pink-500": props.category.color === "#F3407F",
  "bg-pink-50": props.category.color === "#F3407F",
  "text-yellow-500": props.category.color === "#864817",
  "bg-yellow-50": props.category.color === "#864817",
  "text-gray-500": props.category.color === "#676C75",
  "bg-gray-50": props.category.color === "#676C75",
  "text-amber-500": props.category.color === "#ffa000",
  "bg-amber-50": props.category.color === "#ffa000",
  "text-zinc-500": props.category.color === "#2C2C2C",
  "bg-zinc-50": props.category.color === "#2C2C2C",
  "text-cyan-500": props.category.color === "#00bcd4",
  "bg-cyan-50": props.category.color === "#00bcd4",
  "text-sky-500": props.category.color === "#2196f3",
  "bg-sky-50": props.category.color === "#2196f3",
  "text-slate-500": props.category.color === "#607d8b",
  "bg-slate-50": props.category.color === "#607d8b",
  "text-stone-500": props.category.color === "#795546",
  "bg-stone-50": props.category.color === "#795546",
  "text-fuchsia-500": props.category.color === "#9c27b0",
  "bg-fuchsia-50": props.category.color === "#9c27b0",
  "text-orange-500": props.category.color === "#ff9800",
  "bg-orange-50": props.category.color === "#ff9800",
  "text-blue-500": props.category.color === "#2368ff",
  "bg-blue-50": props.category.color === "#2368ff",
  "text-green-500": props.category.color === "#2bbd38",
  "bg-green-50": props.category.color === "#2bbd38",
}));
</script>

<style>
.material-symbols-outlined {
  font-variation-settings: "FILL" 0, "wght" 200, "GRAD" -25, "opsz" 20;
}
</style>
